// extracted by mini-css-extract-plugin
export var fadeInAnimation = "ProjectsSlider-module--fadeInAnimation--505de";
export var layout = "ProjectsSlider-module--layout--4af11";
export var noResults = "ProjectsSlider-module--noResults--937c4";
export var slider = "ProjectsSlider-module--slider--de875";